import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { UserGroupRecord } from "../UserGroupRecord";

export function getQueryKey() {
  return ["userGroupRecords"];
}

export function useUserGroups() {
  const { userGroupService } = useDomainServices();

  return useQuery<UserGroupRecord[], Error>({
    queryKey: getQueryKey(),
    queryFn({ signal }) {
      return userGroupService.getAll({ abortSignal: signal });
    },
  });
}
